// @flow

import * as types from "../ACTIONS/actionTypes";
import initialState from "./initialState";
import commonInitialState from "../GUI_COMMON/REDUCERS/commonInitialState"; // if any

import adminReducer from "./adminReducer";
import caseReducer from "./caseReducer";
import sampleReducer from "./sampleReducer";
import statsReducer from "./statsReducer";
import profilesReducer from "./profilesReducer";
import retrievalReducer from "./retrievalReducer";
import pickSheetReducer from "./pickSheetReducer";
import locationReducer from "./locationReducer";
import contactReducer from "./contactReducer";
import chaseListReducer from "./chaseListReducer";
import watchListReducer from "./watchListReducer.cs";
import serverInfoReducer from "./serverInfoReducer";
import notificationReducer from "./notificationReducer";
import searchReducer from "./searchReducer";
import magTypeReducer from "./magTypeReducer";
import sampleTypeReducer from "./sampleTypeReducer";
import {commonAppReducer} from "../GUI_COMMON/REDUCERS/commonAppReducer";
import btoReducer from "./btoReducer";

// this combines the state from each of the reducers into our initial state
// NOTE: we remap the reducers to their better known names in the larger
// state object here.
function appReducer(state = initialState, action) {
    
    // we return the new state object here
    const updatedStates = {
        adminInfo: adminReducer(state.adminInfo, action),
        case: caseReducer(state.case, action),
        sample: sampleReducer(state.sample, action),
        stats: statsReducer(state.stats, action),
        profiles: profilesReducer(state.profiles, action),
        retrievals: retrievalReducer(state.retrievals,action),
        btos: btoReducer(state.btos,action),
        picksheet: pickSheetReducer(state.picksheet,action),
        locations: locationReducer(state.locations,action),
        contacts: contactReducer(state.contacts, action),
        chaseList: chaseListReducer(state.chaseList, action),
        watchList: watchListReducer(state.watchList, action),
        archiverServerInfo: serverInfoReducer(state.archiverServerInfo, action),
        notifications: notificationReducer(state.notifications, action),
        searchResults: searchReducer(state.searchResults, action),
        magTypes: magTypeReducer(state.magTypes, action),
        sampleTypes: sampleTypeReducer(state.sampleTypes, action)
    };
    return {...state,...updatedStates} // local states overwrite common states?
}

const rootReducer = (state, action) => {
    switch(action.type) {
        case types.CLEAR_STATE_ON_LOGOUT: {
            return {...commonInitialState,...initialState};     // null out the store on logout.
        }
        default:
            // common reducers first, then these get overwritten by the app's reducers.
            let commonState = commonAppReducer(state, "-1", action);  // client id for common is always -1 (archiver doesn't care)
            let finalState = appReducer(commonState, action);  // NOTE: we pass the new state to the appReducer
            return finalState; // updated state here
    }
};

export default rootReducer;